const SETTINGS_ROUTES = {
  APP_INTEGRATIONS: '/settings/app_integrations',
  ARCHIVED_CLASSES: '/settings/archived_classes',
  BLOCKED_USERS: '/settings/blocked_users',
  INDIVIDUAL_PLAN: '/settings/individual_plan',
  MESSAGE_HISTORY: '/settings/message_history',
  NOTIFICATIONS: '/settings/notifications',
  PROFILE: '/settings/profile',
  WIDGETS: '/settings/widgets',
};

export default SETTINGS_ROUTES;
